import Image from 'next/image';
import Link from 'next/link';

import Layout from '~components/ui/Layout';

import s from '../styles/pages/CustomErrorPage.module.css';

export default function Custom500() {
  return (
    <Layout meta={{ title: 'Error 500' }}>
      <div className={s.root}>
        <div className="w-[90%]">
          <Image
            src="/img/error500.png"
            alt="Imagen de error 500"
            layout="responsive"
            width={397}
            height={343}
          />
        </div>
        <h1 className={s.errorTitle}>Oops.. parece que salió algo mal</h1>
        <p className={s.errorCopy}>
          Esta es una página 500. Eso significa que existe un error inesperado en el servidor. Por
          favor vuelve a intentarlo más tarde.
        </p>
        <Link href="/" className="btn btn-secondary btn-lg">
          Ir a la cartelera
        </Link>
      </div>
    </Layout>
  );
}
